import {Carousel} from "../custom-elements/scroller/carousel.js";
import {ServerApi} from "../api.js";
import {handleFetchError, showNotice} from "../helpers/functions.js";
import JSX from "../helpers/react.js";

$('html')
    .on('click', '.do-not-recommend',async function (){
        const $this = $(this);
        if($this.hasClass('blocked'))return;
        $this.addClass('blocked');
        try {
            const $anime = $this.closest('.anime-cell') as JQuery<Carousel>;
            const animeId = $anime.data('anime-id')! as number;
            if($anime.hasClass('deleted')){
                await ServerApi.anime.recommend(animeId);
                showNotice('Ладно, уговорил, будем рекомендовать', 'Отлично (👍ᐛ )👍', 'success');
                setTimeout(()=>$(this).html(<i className="fa fa-ban" />), 300);
                $anime.removeClass('deleted');
                $this.attr('data-balloon', 'Не рекомендовать')

            }
            else {
                await ServerApi.anime.doNotRecommend(animeId);
                showNotice('Больше не будем рекомендовать это аниме', 'Твои вкусы учтены (👍ᐛ )👍', 'success');
                $anime.addClass('deleted');
                $this.attr('data-balloon', 'Рекомендовать')
            }
            $this.find('.fa').toggleClass('fa-plus fa-ban')
                // .toggleClass('fa-ban');

        }
        catch (e){
            handleFetchError(e);
        }
        finally {
            $this.removeClass('blocked');
        }
    })